document.addEventListener('DOMContentLoaded',function(){
  var hdr=document.querySelector('.hdr');
  if(hdr){window.addEventListener('scroll',function(){hdr.classList.toggle('scrolled',window.scrollY>40);},{passive:true});}
  var b=document.querySelector('.nav-burger'),m=document.querySelector('.nav-mobile');
  if(b&&m){b.addEventListener('click',function(){m.classList.toggle('open');b.classList.toggle('x');document.body.classList.toggle('noscroll');});
    m.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){m.classList.remove('open');b.classList.remove('x');document.body.classList.remove('noscroll');});});}
  var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target);}});},{threshold:0.14});
  document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
  /* interactive lamp — glow follows cursor proximity, like the real sensor */
  var hero=document.querySelector('.hero'),lamp=document.querySelector('.lamp-body'),halo=document.querySelector('.halo'),hint=document.querySelector('.lamp-hint');
  if(hero&&lamp){
    var touched=false;
    hero.addEventListener('mousemove',function(ev){
      touched=true;
      var r=hero.getBoundingClientRect(),lr=lamp.getBoundingClientRect();
      var lx=lr.left+lr.width/2-r.left, ly=lr.top+lr.height/2-r.top;
      var mx=ev.clientX-r.left, my=ev.clientY-r.top;
      var d=Math.hypot(mx-lx,my-ly);
      var li=Math.max(.08,Math.min(1,1-(d-90)/520));
      hero.style.setProperty('--li',li.toFixed(3));
      if(halo){halo.style.left=mx+'px';halo.style.top=my+'px';halo.style.opacity=1;}
      if(li>.92&&hint&&!hint.classList.contains('done')){hint.classList.add('done');hint.textContent='Där. Precis så snabb är den hemma hos dig.';}
    });
    hero.addEventListener('mouseleave',function(){hero.style.setProperty('--li',.12);if(halo)halo.style.opacity=0;});
    /* touch fallback: gentle automatic pulse */
    setTimeout(function(){if(!touched){hero.classList.add('autopulse');}},2500);
    lamp.addEventListener('click',function(){hero.classList.toggle('lit');});
  }
  /* kelvin toggle */
  document.querySelectorAll('.kelvin button').forEach(function(kb){
    kb.addEventListener('click',function(){
      document.querySelectorAll('.kelvin button').forEach(function(x){x.classList.remove('on');});
      kb.classList.add('on');
      if(hero)hero.setAttribute('data-k',kb.dataset.k);
    });
  });
  /* stat count-up */
  var sio=new IntersectionObserver(function(es){es.forEach(function(e){
    if(!e.isIntersecting)return;sio.unobserve(e.target);
    var el=e.target,n=parseInt(el.dataset.n),suf=el.dataset.s||'',t0=null;
    function step(t){if(!t0)t0=t;var p=Math.min(1,(t-t0)/1200);p=1-Math.pow(1-p,3);el.textContent=Math.round(n*p)+suf;if(p<1)requestAnimationFrame(step);}
    requestAnimationFrame(step);
  });},{threshold:.6});
  document.querySelectorAll('.count').forEach(function(el){sio.observe(el);});
  /* qty steppers */
  document.querySelectorAll('.qty').forEach(function(q){var i=q.querySelector('input');q.querySelectorAll('button').forEach(function(btn){btn.addEventListener('click',function(ev){ev.preventDefault();var v=parseInt(i.value||'1');if(btn.dataset.d==='-'){if(v>1)i.value=v-1;}else{i.value=v+1;}});});});
});